// extracted by mini-css-extract-plugin
export default {"loggedOutDisplay":"MyQueue_loggedOutDisplay__-pwun","loggedInDisplay":"MyQueue_loggedInDisplay__T1GzV","requestedSongsContainer":"MyQueue_requestedSongsContainer__G-QMp"};